// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "main" + "-" + "2acfa77878fb6385a147" + ".css";
};